import React from "react";
import SettlementTable from "./components/SettlementTable";

const SettlementHead = () => {
    return (
        <>
        <SettlementTable/>
        </>
    )
}
export default SettlementHead;